module.exports = __webpack_public_path__ + "img/711ms.228904cc.png";